import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '../icon/icon.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-back-to',
  templateUrl: './back-to.component.html',
  styleUrls: ['./back-to.component.scss'],

  imports: [CommonModule, TranslateModule, IconComponent],
})
export class BackToComponent {
  label = input.required<string>();
  route = input<string>();

  constructor(private router: Router) {}

  goBack() {
    this.route() && this.router.navigateByUrl(this.route());
  }
}
